import React, { FC } from 'react';
import classNames from 'classnames';
import { useTheme } from '@mui/material/styles';

import AndroidIcon from '@assets/android.svg';
import IOSIcon from '@assets/ios.svg';
import PCIcon from '@assets/pc.svg';
import VRIcon from '@assets/vr.svg';
import ARIcon from '@assets/ar.svg';
import MobileIcon from '@assets/tablet.svg';

import { ThemeProps } from '@styles/theme';
import { useStyles } from './PlatformBadge.styles';

const PLATFORM_ICONS: Record<string, string> = {
    android: AndroidIcon,
    ios: IOSIcon,
    pc: PCIcon,
    windows: PCIcon,
    osx: PCIcon,
    vr: VRIcon,
    ar: ARIcon,
    mobile: MobileIcon,
    tablet: MobileIcon,
};

type PlatformBadgeProps = {
    platform?: string | null,
    size?: 'small' | 'normal',
};

export const PlatformBadge: FC<PlatformBadgeProps> = ({ platform, size = 'normal' }) => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    if (!platform) {
        return null;
    }

    const icon = PLATFORM_ICONS[platform.toLowerCase()];

    return (
        <span className={styles.badge}>
            {icon && (
                <img
                    src={icon}
                    alt={platform}
                    className={classNames(styles.icon, { [styles.iconSmall]: size === 'small' })}
                />
            )}
            <span className={styles.label}>{platform}</span>
        </span>
    );
};

PlatformBadge.displayName = 'PlatformBadge';
